module.exports = __webpack_public_path__ + "static/media/Pause.a539416e.svg";